import { ExportsPanel } from "@/features/exports/components/ExportsPanel";
import { ImportSection } from "@/features/exports/components/ImportSection";
import { PropertyTabExportMenu } from "@/features/exports/components/PropertyTabExportMenu";
import FileManager from "@/features/properties/components/FileManager";
import { PropertyAssetRegistry } from "@/features/properties/components/PropertyAssetRegistry";
import { PropertyDeficienciesGallery } from "@/features/properties/components/PropertyDeficienciesGallery";
import { PropertyOverviewTab } from "@/features/properties/components/PropertyOverviewTab";
import { PropertyReportGallery } from "@/features/properties/components/PropertyReportGallery";
import { PropertySiteAttributesTab } from "@/features/properties/components/PropertySiteAttributesTab";
import { VRTourManager } from "@/features/properties/components/vr/VRTourManager";
import type { Property, PropertyTab } from "./types";

interface PropertyDetailContentProps {
  activeTab: PropertyTab;
  clientId: string;
  propertyId: string;
  property: Property;
  exportsEnabled: boolean;
  onJumpToExports: () => void;
}

export function PropertyDetailContent({
  activeTab,
  clientId,
  propertyId,
  property,
  exportsEnabled,
  onJumpToExports,
}: PropertyDetailContentProps) {
  const propertyLabel = property?.name || "Property";

  return (
    <div className="flex-1 overflow-auto p-6 animate-fade-in">
      {activeTab === 'overview' && (
        <PropertyOverviewTab propertyId={propertyId} />
      )}
      {activeTab === 'assets' && (
        <PropertyAssetRegistry
          propertyId={propertyId}
          headerActions={
            exportsEnabled ? (
              <PropertyTabExportMenu
                activeTab="assets"
                clientId={clientId}
                propertyId={propertyId}
                propertyLabel={propertyLabel}
                onJumpToExportsTab={onJumpToExports}
              />
            ) : undefined
          }
        />
      )}
      {activeTab === 'site-attributes' && (
        <PropertySiteAttributesTab
          propertyId={propertyId}
          headerActions={
            exportsEnabled ? (
              <PropertyTabExportMenu
                activeTab="site-attributes"
                clientId={clientId}
                propertyId={propertyId}
                propertyLabel={propertyLabel}
                onJumpToExportsTab={onJumpToExports}
              />
            ) : undefined
          }
        />
      )}
      {activeTab === 'photos' && (
        <PropertyReportGallery
          clientId={clientId}
          propertyId={propertyId}
          propertyName={property.name}
        />
      )}
      {activeTab === 'vr' && (
        <VRTourManager propertyId={propertyId} />
      )}
      {activeTab === 'files-documents' && (
        <FileManager
          propertyId={propertyId}
          headerActions={
            exportsEnabled ? (
              <PropertyTabExportMenu
                activeTab="3d"
                clientId={clientId}
                propertyId={propertyId}
                propertyLabel={propertyLabel}
                onJumpToExportsTab={onJumpToExports}
              />
            ) : undefined
          }
        />
      )}
      {activeTab === 'deficiencies' && (
        <PropertyDeficienciesGallery
          clientId={clientId}
          propertyId={propertyId}
          propertyName={property.name}
        />
      )}
      {activeTab === 'exports' && exportsEnabled && (
        <div className="space-y-8">
          <ImportSection
            scope={{ kind: "property", projectId: clientId, propertyId }}
            label={propertyLabel}
          />

          <hr className="border-border/40" />

          <section className="space-y-4">
            <h2 className="text-lg font-semibold text-foreground">Export</h2>
            <ExportsPanel
              scope={{ kind: "property", projectId: clientId, propertyId }}
              label={propertyLabel}
            />
          </section>
        </div>
      )}
    </div>
  );
}
